// extracted by mini-css-extract-plugin
module.exports = {"root":"search_root__ZmNKX","expanded":"search_expanded__2HSnp","cancel":"search_cancel__31ZBQ"};